import React from 'react'
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Circle  } from "react-google-maps"

const MapDetails = withScriptjs(withGoogleMap((props) => 
        <GoogleMap
        defaultZoom={props.size <= 30 ? 9 : props.size <= 60 ? 8 :props.size <= 140 ? 7 : props.size <= 300 ? 6 : 5}
        defaultCenter={{ lat: props.latt ? props.latt : -34.397, lng: props.lngg ? props.lngg : 150.644 }}
    >
        <Circle 
        center={{ lat: props.latt ? props.latt : -34.397, lng: props.lngg ? props.lngg : 150.644 }}
        options={{
            strokeColor: '#000000',
            strokeOpacity: 0.5,
            strokeWeight: 2,
            fillColor: '#000000',
            fillOpacity: 0.5,
            clickable: false,
            draggable: false,
            editable: false,
            visible: true,
            radius: props.size*1000,
            zIndex: 1
        }}
        ></Circle>
        {props.isMarkerShown && <Marker position={{ lat: props.latt ? props.latt : -34.397, lng: props.lngg ? props.lngg : 150.644 }} /> }
        </GoogleMap>
    ))

export default MapDetails
